"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeCheckbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
var IndeterminateCheckbox_1 = require("../../forms/IndeterminateCheckbox");
var NodeCheckbox = function (_a) {
    var node = _a.node, checked = _a.checked, indeterminate = _a.indeterminate, onToggleCheckbox = _a.onToggleCheckbox, children = _a.children;
    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.FormGroup, __assign({ check: true, className: "d-flex align-items-center flex-grow-1 mb-0", onClick: function (e) { return e.stopPropagation(); } }, { children: [(0, jsx_runtime_1.jsx)(IndeterminateCheckbox_1.IndeterminateCheckbox, { id: "check-".concat(node.id), "data-testid": "tree-node-check-".concat(node.id), className: "x5-me-2 flex-shrink-0", checked: checked, indeterminate: indeterminate, onChange: function () { return onToggleCheckbox === null || onToggleCheckbox === void 0 ? void 0 : onToggleCheckbox(node); }, tabIndex: -1 }), (0, jsx_runtime_1.jsx)(reactstrap_1.Label, __assign({ for: "check-".concat(node.id), check: true, className: "flex-grow-1" }, { children: children }))] })));
};
exports.NodeCheckbox = NodeCheckbox;
